import { render } from "./TranslateObjectView.vue?vue&type=template&id=2b3900e6"
import script from "./TranslateObjectView.vue?vue&type=script&lang=js"
export * from "./TranslateObjectView.vue?vue&type=script&lang=js"

import "./TranslateObjectView.vue?vue&type=style&index=0&id=2b3900e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__